import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { UserInfo } from "../../context";
import axios from "axios";
import moment from "moment";
import { Chip, Dialog, Hidden, TablePagination } from "@mui/material";
import { AddBusiness } from "@mui/icons-material";
import QRCode from "react-qr-code";
import CustomerOrderDetails from "../order-details";
import InfoIcon from '@mui/icons-material/Info';
import QrCodeIcon from '@mui/icons-material/QrCode';

const CustomerOrders = () => {
  const { userData } = React.useContext(UserInfo);
  const [customerProducts, setCustomerProducts] = React.useState({
    data: [],
    ready: false,
  });
  const [viewQR, setViewQR] = React.useState(false);
  const [selectedTranx, setSelectedTranx] = React.useState("")
  const [selectedOrder, setSelectedOrder] = React.useState(null);
  const [viewOrder, setViewOrder] = React.useState(false);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getCustomerOrders = () => {
    var params = { user_id: userData.data.id };
    axios
      .get("customer/get/orders", { params })
      .then((response) => {
        const data = response.data;
        // console.log("data", data);
        setCustomerProducts({ data, ready: true });
      })
      .catch((err) => console.log("err", err));
  };

  React.useEffect(() => {
    getCustomerOrders();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Box
        sx={{
          width: "100vw",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 2,
            mt: 2,
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "1165px",
              mx: "15px",
            }}
          >
            <Typography variant="h5">My Orders</Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            // justifyContent: "center",
            alignItems: "center",
            paddingX: "15px",
          }}
        >
          {customerProducts.data.map((data, index) => (
            <Box
              key={index}
              sx={{
                borderTop: "1px solid #AEAEAE",
                borderLeft: "1px solid #AEAEAE",
                borderBottom: "1px solid #AEAEAE",
                borderRight: "4px solid green",
                borderRadius: 2,
                width: "100%",
                maxWidth: "1165px",
                display: "flex",
                alignItems: "center",
                padding: 1,
                mb: 1
              }}
            >
              <Box sx={{ mr: 2 }}>
                <AddBusiness sx={{ fontSize: "28px" }} />
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography
                  gutterBottom
                  variant="subtitle1"
                  sx={{ fontWeight: 700 }}
                >
                  {data.trnxid.replace("t-", "")}
                </Typography>
                <Typography
                  gutterBottom
                  variant="caption"
                >
                  {moment(data.created_at).utc(0).format('lll')}
                </Typography>
              </Box>
              <Box flexGrow={1} />
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: 120 }}>
                <Chip size="small"
                  label={
                    data.status === "order-placed" ?
                      "Order placed"
                      : data.status === "order-preparing" ?
                        "Order preparing"
                        : data.status === "order-ready" ?
                          "Order ready"
                          : data.status === 'order-pickup' ?
                            "Order picked up"
                            : data.status === 'order-delivered' ?
                              data.rider_id === 'pick-up' ?
                                "Collected"
                                : "Delivered"
                              : "Waiting for rider"
                  }
                  color={data.status === 'order-delivered' ? 'success' : 'primary'}
                  variant="outlined" />
              </Box>
              <Hidden smDown>
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: 80 }}>
                  <Typography
                    sx={{
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: 12,
                      backgroundColor: "#50C878",
                      borderRadius: 1,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      padding: 1
                    }}
                    onClick={() => {
                      setViewQR(true);
                      setSelectedTranx(data.trnxid)
                    }}
                  >
                    QR TRNX
                  </Typography>
                </Box>
              </Hidden>
              <Hidden smUp>
                <QrCodeIcon
                  sx={{ color: "#50C878", cursor: "pointer" }}
                  onClick={() => {
                    setViewQR(true);
                    setSelectedTranx(data.trnxid)
                  }}
                />
              </Hidden>

              <Hidden smDown>
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: 80 }}>
                  <Typography
                    sx={{
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: 12,
                      backgroundColor: "#04D4F0",
                      borderRadius: 1,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      padding: 1
                    }}
                    onClick={() => {
                      setSelectedOrder(data);
                      setViewOrder(true);
                    }}
                  >
                    DETAILS
                  </Typography>
                </Box>
              </Hidden>
              <Hidden smUp>
                <InfoIcon
                  sx={{ color: "#04D4F0", cursor: "pointer" }}
                  onClick={() => {
                    setSelectedOrder(data);
                    setViewOrder(true);
                  }}
                />
              </Hidden>
            </Box>
          ))}
          <Box sx={{
            display: "flex",
            width: "100%",
            maxWidth: "1165px",
          }}>
            <Box flexGrow={1} />
            <TablePagination
              rowsPerPageOptions={[10, 15, 25]}
              component="div"
              count={customerProducts.data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Box>
        </Box>

        <Dialog
          open={viewQR}
          onClose={() => setViewQR(false)}
          maxWidth="xs"
          fullWidth
        >
          <Box sx={{ padding: 5 }}>
            <QRCode
              size={256}
              style={{ height: "auto", maxWidth: "100%", width: "100%" }}
              value={selectedTranx}
              viewBox={`0 0 256 256`}
            />
          </Box>

        </Dialog>

        <Dialog
          open={viewOrder}
          onClose={() => setViewOrder(false)}
          maxWidth="sm"
          fullWidth
        >
          <CustomerOrderDetails
            selectedOrder={selectedOrder}
            close={() => {
              setViewOrder(false);
            }}
          />
        </Dialog>
      </Box>
    </>
  );
};
export default CustomerOrders;
